import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, vShow as _vShow, withDirectives as _withDirectives, normalizeStyle as _normalizeStyle, renderSlot as _renderSlot, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = (n: any) => (_pushScopeId("data-v-60288116"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "se-tab" }
const _hoisted_2 = {
  ref: "tabContainer",
  class: "tab-container"
}
const _hoisted_3 = ["onClick"]
const _hoisted_4 = {
  key: 0,
  style: {"width":"24px","height":"24px"}
}
const _hoisted_5 = ["src"]
const _hoisted_6 = {
  style: {"pointer-events":"none"},
  class: "tab-text no-select"
}
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "indicator" }, null, -1))
const _hoisted_8 = {
  key: 0,
  ref: "stickContainer",
  class: "sticky"
}
const _hoisted_9 = { key: 0 }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", {
        ref: "tabBar",
        class: "tab-bar",
        style: _normalizeStyle({ backgroundColor: _ctx.tabBackgroundColor })
      }, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.tabs, (label) => {
          return _withDirectives((_openBlock(), _createElementBlock("div", {
            key: label,
            class: "tab active",
            onClick: () => _ctx.changeTab(label)
          }, [
            (_ctx.icons != null)
              ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
                  _createElementVNode("img", {
                    style: {"pointer-events":"none"},
                    src: _ctx.icons[_ctx.tabs.indexOf(label)]
                  }, null, 8, _hoisted_5)
                ]))
              : _createCommentVNode("", true),
            _createElementVNode("span", _hoisted_6, _toDisplayString(label), 1)
          ], 8, _hoisted_3)), [
            [_vShow, !_ctx.hiddenIndexes.includes(_ctx.tabs.indexOf(label))]
          ])
        }), 128)),
        _hoisted_7
      ], 4)
    ], 512),
    (_ctx.$slots.sticky)
      ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
          _renderSlot(_ctx.$slots, "sticky", {}, undefined, true)
        ], 512))
      : _createCommentVNode("", true),
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.tabs, (tab) => {
      return (_openBlock(), _createElementBlock("div", { key: tab }, [
        (_ctx.tabs.indexOf(tab) == _ctx.selectedIndex)
          ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
              _renderSlot(_ctx.$slots, _ctx.selectedIndex, {}, undefined, true)
            ]))
          : _createCommentVNode("", true)
      ]))
    }), 128))
  ]))
}